<template>
  <main id="companies">
    <formhero/>
    <location />
    <cta />
    <speakers />
    <presenters />
    <sponsors />
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import formhero from '@/components/formhero.vue';
import location from '@/components/location.vue';
import cta from '@/components/cta.vue';
import sponsors from '@/components/sponsors.vue';
import presenters from '@/components/presenters.vue';
import speakers from '@/components/speakers.vue';

export default {
  name: 'Companies',
  data() {
    return {
    };
  },
  components: {
    formhero,
    location,
    cta,
    sponsors,
    presenters,
    speakers
  },
  methods: {
  },
  mounted() {
  },
};
</script>
